import { IComponentOptions, module } from 'angular';

const resizeCapacityComponent: IComponentOptions = {
  bindings: {
    command: '=',
    currentSize: '=',
    serverGroup: '='
  },
  templateUrl: require('./resizeCapacity.component.html'),
  controller: () => {}
};

export const AWS_RESIZE_CAPACITY_COMPONENT = 'spinnaker.amazon.serverGroup.resize';
module(AWS_RESIZE_CAPACITY_COMPONENT, []).component('awsResizeCapacity', resizeCapacityComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/serverGroup/details/resize/resizeCapacity.component.ts